import React, { useEffect, useState } from "react";
import "./assets/css/TemplateDesign.css";
import ResizableDataMatrix from "./ResizableDataMatrix";

const DataMatrixComponent = (props) => {
  const [width] = useState(props.width);
  const [height] = useState(props.height);

  function setDataMatrixDesign(htmldata, id, left, top, width, height) {
    props.parentSetDataMatrixDesign(
      htmldata,
      id,
      left,
      top,
      width,
      height,
      props.title
    );
  }

  return (
    <>
      <ResizableDataMatrix
        top={props.top}
        left={props.left}
        width={width}
        height={height}
        parentSetDataMatrixDesign={setDataMatrixDesign}
        id={props.id}
        title={props.title}
        data_matrix_swap={props.data_matrix_swap}
      ></ResizableDataMatrix>
    </>
  );
};

export default DataMatrixComponent;
